<div class="modal-header">
  <h4 id="approve-item-modal" class="modal-title">
    {{ "Approve" | translate }}: {{ equipmentItemService.getName$(equipmentItem) | async }}
  </h4>

  <button (click)="cancel()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <ng-container *ngIf="similarItems$ | async as similarItems">
    <div *ngIf="similarItems.length > 0" class="alert alert-warning">
      <h5>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        {{ "Warning!" | translate }}
      </h5>
      <astrobin-similar-items-suggestion
        [items]="similarItems"
        [preamble]="similarItemsPreamble"
      ></astrobin-similar-items-suggestion>
    </div>
  </ng-container>

  <div *ngIf="othersInBrand.length > 0" class="alert alert-info">
    <astrobin-equipment-others-in-brand [items]="othersInBrand"></astrobin-equipment-others-in-brand>
  </div>

  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <div *ngIf="!!equipmentItem.brand" class="alert alert-info mb-3">
    <p>
      {{ "This operation will make the item available to everyone on AstroBin." | translate }}
      <span [innerHTML]="consultHandbookMessage"></span>
    </p>
  </div>

  <button (click)="cancel()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="!form.valid"
    (click)="approve()"
    class="btn btn-success"
    type="button"
  >
    {{ "Approve" | translate }}
  </button>
</div>
